import React, { useState } from 'react';
import { Zap, Mail, Heart } from 'lucide-react'; 
import { FaGithub, FaInstagram, FaXTwitter } from 'react-icons/fa6'; 
import './Footer.css';
import { subscribeToNewsletter } from '../api/studentApi';
import { toast } from 'react-toastify';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const [email, setEmail] = useState("");

  const handleSubscribe = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;

    try {
      const response = await subscribeToNewsletter(email);
      if (response.data?.success) {
        toast.success("You're on the list! Check your inbox for your first fun tip.");
      }
    } catch (err) {
      toast.error("Failed to subscribe. Please try again.");
    } finally {
      setEmail("");
    }
  };

  return (
    <footer className="main-footer">
      <div className="footer-container">
        {/* BRAND COLUMN */}
        <div className="footer-brand">
          <div className="logo">
            <Zap className="logo-icon" fill="#6366f1" color="#6366f1" />
            <span>Knolup</span>
          </div>
          <p className="brand-desc">
            Making learning an adventure for students everywhere.
            Join thousands of explorers mastering their subjects today.
          </p>
          <div className="social-links">
            <a href="#" aria-label="Twitter" rel="noreferrer"><FaXTwitter /></a>
            <a href="https://www.instagram.com/theknolup/" aria-label="Instagram" target="_blank" rel="noreferrer"><FaInstagram /></a>
            <a href="#" aria-label="Github" rel="noreferrer"><FaGithub /></a>
          </div>
        </div>

        {/* QUICK LINKS */}
        <div className="footer-group">
          <h4>Platform</h4>
          <ul>
            <li><a href="#features">Features</a></li>
            <li><a href="/curriculum">Curriculum</a></li>
            <li><a href="/leaderboards">Leaderboard</a></li>
            <li><a href="/pricing">Pricing</a></li>
            <li><a href="/printables">Free Printables</a></li>
          </ul>
        </div>

        {/* SUPPORT */}
        <div className="footer-group">
          <h4>Support</h4>
          <ul>
            <li><a href="/help-center">Help Center</a></li>
            <li><a href="/privacy-policy">Privacy Policy</a></li>
            <li><a href="/terms-of-service">Terms of Service</a></li>
            <li><a href="#">Contact Us</a></li>
          </ul>
        </div>

        {/* NEWSLETTER */}
        <div className="footer-newsletter">
          <h4>Stay Updated</h4>
          <p>Get fun study tips and new quiz alerts!</p>
          <form className="newsletter-form" onSubmit={handleSubscribe}>
            <input 
              type="email" 
              placeholder="Email address" 
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)} 
            />
            <button type="submit" className="btn-send" aria-label="Subscribe">
              <Mail size={18} />
            </button>
          </form>
        </div>
      </div>

      <div className="footer-bottom">
        <p>
          © {currentYear} Knolup. Made with
          <Heart size={14} fill="#ef4444" color="#ef4444" style={{ margin: '0 5px' }} />
          for a brighter future.
        </p>
      </div>
    </footer>
  );
};

export default Footer;